export default __webpack_public_path__ + "static/media/taza.d53686a0.PNG";